import sizeHtmlApi from "./sizeHtml";

const { sanitizeSizeHtml, sizeHasHtml } = sizeHtmlApi;

export { sizeHasHtml };

export default function SizeHtml({ value }) {
  const raw = value == null ? "" : String(value);
  if (!sizeHasHtml(raw)) return raw;
  return <span className="tc-size-html" dangerouslySetInnerHTML={{ __html: sanitizeSizeHtml(raw) }} />;
}
